import { Box } from '../layout/Box';
import { ModalHeaderProps } from './interface-modal';

export const ModalHeader = ({ children }: ModalHeaderProps) => (
  <Box marginBottom="32px">{children}</Box>
);
